<template>
    <div v-if="isValidContract">
        <h5>Consignes</h5>

        <div>
            <dt>Motif de votre absence : </dt>
            <dd>{{ hotlineInstruction.decoded_absence_reason }}</dd>

            <dt>Consignes concernant les prises de message : </dt>
            <dd>{{ hotlineInstruction.decoded_message_taking }} 
                <span v-if="'provide_info' == hotlineInstruction.message_taking">{{ hotlineInstruction.message_taking_phone}}</span></dd>

            <dt>Gestion des urgences : </dt>
            <dd>{{ hotlineInstruction.decoded_emergency_management }}</dd>

            <dt>Commentaires : </dt>
            <dd>{{ simpleHotlineContractOption.comments }}</dd>
        </div>
    </div>
    <div v-else>Aucune option de permanence téléphonique simple n'est associée à ce contrat</div>
</template>

<script>
export default {
    name:"HotlineInstruction",
    props:["contract"],

    data () {
        return {}
    },

    computed: {
        simpleHotlineContractOption() {
            return _.filter(this.contract.contract_options, co => co.option.simple_hotline == true && _.includes(['active', 'pending-termination'], co.status))[0]
        },

        isValidContract() {
            return this.simpleHotlineContractOption != undefined
        },

        hotlineInstruction() {
            return this.isValidContract ? this.simpleHotlineContractOption.hotline_instruction : null
        }
    }
}
</script>


// WEBPACK FOOTER //
// client/components/Customer/HotlineContent/HotlineInstruction.vue